<template>
  <b-nav vertical class="w-100 vertical-nav">
    <!-- dynamic menu -->
    <b-nav-item
      v-for="mi in menuItems"
      :key="mi.title"
      :active="mi.active"
      @click="mi.children?mi.childVisible=!mi.childVisible:$router.push({ name:mi.routeName})"      
    >
      <div v-if="hasPermissions(mi.permissions)">
        <div class="nav-menu-icon">
          <i :class="mi.icon"></i>
        </div>

        <div class="nav-menu-text">{{ mi.title }}</div>

        <span v-if="mi.children">
          <div class="nav-menu-chevron">
            <i class="dd-ico lni lni-chevron-right" v-show="!mi.childVisible"></i>
            <i class="dd-ico lni lni-chevron-up" v-show="mi.childVisible"></i>
          </div>

          <div style="clear:both;"></div>

          <transition name="slide">
            <div class="menu-item-dropdown-con" v-if="mi.childVisible">
              <div
                class="sub-menu-item"
                v-for="mc in mi.children"
                :key="mc.title"
                @click="$router.push({ name:mc.routeName})"
              >
                 <div v-if="hasPermissions(mc.permissions)">
                  - {{ mc.title }}
                </div>
              </div>
            </div>
          </transition>
        </span>
      </div>
      <div style="clear:both;"></div>
    </b-nav-item>
  </b-nav>
</template>

<script>
import menuData from "@/data/menu";
import store from "@/store";

export default {
  data() {
    return {
      menuItems: menuData,
      permissions: []
    };
  },

  mounted(){
    this.routeWatcher()
    this.permissions = this.$store.state.user.permissions.map(x => x.name)
  },

  watch: {
    $route() {
      this.routeWatcher()
    }
  },

  methods:{
    routeWatcher(){

      this.menuItems.forEach(item => {
        if (this.hasPath(item.paths)) {
          item.active = true;
        } else {
          item.active = false;
        }
      });

      //Close the menu by default if mobile when route changes
      if (window.screen.width < 992) {
        store.commit("menu/setMenuState", "close");
      }
    },

    hasPermissions: function (permList) {

      if(permList && permList.length > 0){
        let matches = permList.filter(i => this.permissions.includes(i))
        return matches.length > 0
      }

      return true; //no permissions set show menu
      
    },

    hasPath: function (pathsList) {
        let matches = pathsList.filter(i => (this.$route.path.includes(i)))
        return matches.length > 0         
    }
  }
};
</script>

<style lang="scss" scoped>

.nav-link {
  padding: 0;
  color: #FFF;
}
.nav-link.active {
  background-color: var(--app-background-color);
  color: var(--primary);
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  margin-left: 10px;
  font-weight: 700;
}
.nav-menu-icon {
  float: left;
  font-size: 30px;
  padding: 11px 19px;
}

.nav-menu-text {
  padding-top: 22px;
  float: left;
}

.nav-menu-chevron {
  padding-top: 11px;
  padding-right: 11px;
  float: right;
}

.dropdown-item {
  color: #FFF !important;
}

.menu-item-dropdown-con {
  //background-color: var(--app-background-color);
  padding: 11px 29px;
  border-bottom-left-radius: 24px;
  margin-left: 10px;

  .sub-menu-item{
    //color: var(--primary);
    padding: 0 0 8px 0;
  }

  .sub-menu-item:hover{
    color: var(--warning);
  }

}

.dd-ico {
  float: right;
  font-size: 11px;
  margin-top: 20px;
}
</style>